export default "__VITE_ASSET__C$Y8ZyMX__"